new class productSelect {

    constructor() {

    var productListingComponent = document.querySelectorAll('.product-list-wrapper')[0];
        if (productListingComponent) {
            this.industryToggles = [...productListingComponent.querySelectorAll('.range-list [data-industry-id]')];
            this.otherIndustryToggle = productListingComponent.querySelector('.range-list [data-industry-id="other"]');
            this.otherIndustries = [...productListingComponent.querySelectorAll('.product-list-item[data-industry-id]')];
            this.productItems = [...productListingComponent.querySelectorAll('[data-industries]')];
            this.popularContainer = document.getElementById('js-product-popular-container');
            this.aZContainer = document.getElementById('js-product-a-z-container');
            this.popularTitle = document.getElementById('js-product-popular-title');
            this.aZTitle = document.getElementById('js-product-a-z-title');
            this.defaultId = document.getElementById('default-industry-id').value;
            this.ACTIVE_CLASS = 'is-active';
            this.POPULAR_TAG_CLASS = 'js-popular-tag';
            this.cookieValue = productSelect.returnIndustryCookieValue();

            if (this.industryToggles && this.productItems && this.defaultId) this.init();
        }
  }

  /**
   * Return the value of the jcb-user-industry cookie
   */
  static returnIndustryCookieValue() {
    const val = document.cookie.match('(^|;) ?jcb-user-industry=([^;]*)(;|$)');
    return val ? val[2].trim() : null;
  }

  /**
   * Return an array of the industry items contained in the data-attribute
   * @param item - The item from which to retrieve the values
   * @returns Array - The array of industries to return for the specified item
   */
  static getArrayOfIndustries(item) {
    return item.dataset.industries.split('|');
  }

  /**
   * Return an array of the popular industry items contained in the data-attribute
   * @param item - The item from which to retrieve the values
   * @returns Array - The array of popular industries to return for the specified item
   */
  static getArrayOfPopularIndustries(item) {
    return item.dataset.popularIndustries.split('|');
  }

  /**
   * Return the value of the data-industry attribute from the selected item
   * @param item - The item from which to retrieve the value
   * @returns string - The selected industry
   */
  static getIndustryFromToggle(item) {
    return item.dataset.industryId;
  }

  /**
   * Add active class to specified element
   * @param elm - The element of which to add the active class
   */
  addActiveClass(elm) {
    elm.classList.add(this.ACTIVE_CLASS);
  }

  /**
   * Remove active class from specified element
   * @param elm - The element from which to remove the active class
   */
  removeActiveClass(elm) {
    elm.classList.remove(this.ACTIVE_CLASS);
  }

  /**
   * Remove all children elements from the popular container
   */
  removeAllElementsFromPopularContainer() {
    while (this.popularContainer.firstChild) this.popularContainer.removeChild(this.popularContainer.firstChild);
  }

  /**
   * Append the specified element to the popular container element
   * @param elm - The element to append to the popular container element
   */
  appendElementToPopularContainer(elm) {
    this.popularContainer.appendChild(elm);
  }

  /**
   * Run methods after clicking an industry toggle
   * @param e - The element that has been clicked
   */
  industryToggleClickEvent(e) {
    const industry = productSelect.getIndustryFromToggle(e);

    this.industryToggles.forEach(toggle => this.removeActiveClass(toggle));
    this.addActiveClass(e);

    this.removeAllElementsFromPopularContainer();

    this.productItems.forEach(item => {
      const popularTag = item.querySelector(`.${this.POPULAR_TAG_CLASS}`);

      this.removeActiveClass(popularTag);
      this.removeActiveClass(item);

      if (productSelect.getArrayOfIndustries(item).includes(industry)) {
        if (productSelect.getArrayOfPopularIndustries(item).includes(industry)) {
          this.addActiveClass(popularTag);

          const popularItem = item.cloneNode(true);
          popularItem.classList.add('is-active');

          this.appendElementToPopularContainer(popularItem);
          this.addActiveClass(popularItem);
          return;
        }

        this.addActiveClass(item);
      }
    });

    if (this.popularContainer.hasChildNodes()) {
      this.addActiveClass(this.popularTitle);
      this.addActiveClass(this.popularContainer);
    } else {
      this.removeActiveClass(this.popularTitle);
      this.removeActiveClass(this.popularContainer);
    }

    if (this.aZContainer.contains(this.aZContainer.querySelector('.product-list-item.is-active'))) {
      this.addActiveClass(this.aZTitle);
      this.addActiveClass(this.aZContainer);
    } else {
      this.removeActiveClass(this.aZTitle);
      this.removeActiveClass(this.aZContainer);
    }

  }

  /**
   * Sets the initial toggle based on the existence of the cookie value, and if it matches a toggle
   */
  setInitialBasedOnCookie() {
    const primaryIndustry = this.industryToggles.find(toggle => `{${productSelect.getIndustryFromToggle(toggle)}}` === this.cookieValue) || false;
    const otherIndustry = this.otherIndustries.find(industry => `{${productSelect.getIndustryFromToggle(industry)}}` === this.cookieValue) || false;

    switch (true) {
      case this.cookieValue === 'other' :
        this.industryToggleClickEvent(this.otherIndustryToggle);
        break;
      case primaryIndustry !== false :
        this.industryToggleClickEvent(primaryIndustry);
        break;
      case otherIndustry !== false :
        this.industryToggleClickEvent(this.otherIndustryToggle);
        break;
      default :
        this.industryToggleClickEvent(this.industryToggles[0])
    }
  }

  /**
   * Initialise methods
   */
  init() {
    this.setInitialBasedOnCookie();

    this.industryToggles.forEach(item => item.addEventListener('click', e =>
      this.industryToggleClickEvent(e.target)));
  }

};
